import React, { useState, useEffect, useContext } from "react";
import DataContext from "../../utils/Context/DataContext";
import { Link } from "react-router-dom";

export default function Footer(props) {
  const context = useContext(DataContext);

  useEffect(() => {
    console.log("Footer On mount :", props);
    console.log("Footer context :", context);
  }, []);

  return (
    <div className="bottom-tabs d-lg-none d-flex justify-content-center align-items-center text-center border-top">
      <Link to="/dashboard" className="flex-fill p-2 link-loader">
        <img src={require("../../assets/icon/black/home.svg")} alt="" />
      </Link>
      <Link to="/profile" className="flex-fill p-2 link-loader">
        <img src={require("../../assets/icon/black/user.svg")} alt="" />
      </Link>
      <a
        className="flex-fill p-2 link-loader"
        href="https://1superapp.com/dashboard"
      >
        <img
          src="https://1superapp.com/assets/images/1superapp-logo-plain.png"
          width="25"
        />
      </a>
      <Link to="/notification" className="flex-fill p-2 link-loader">
        <img src={require("../../assets/icon/black/bell.svg")} alt="" />
      </Link>
      <Link to="/activity" className="flex-fill p-2 link-loader">
        <img src={require("../../assets/icon/black/archive.svg")} alt="" />
      </Link>
      {/* <a className="flex-fill p-2 link-loader" href="/dashboard">
        <img src={require("../../assets/icon/black/home.svg")} alt="" />
      </a>
      <a className="flex-fill p-2 link-loader" href="/profile">
        <img src={require("../../assets/icon/black/user.svg")} alt="" />
      </a>
      <a
        className="flex-fill p-2 link-loader"
        href="https://1superapp.com/dashboard"
      >
        <img
          src="https://1superapp.com/assets/images/1superapp-logo-plain.png"
          width="25"
        />
      </a>
      <a className="flex-fill p-2 link-loader" href="">
        <img src={require("../../assets/icon/black/bell.svg")} alt="" />
      </a>
      <a className="flex-fill p-2 link-loader" href="/activity">
        <img src={require("../../assets/icon/black/archive.svg")} alt="" />
      </a> */}
      {/* Menu Button */}
      {/* <div className="flex-fill p-2">
        <button
          className="sidebar-toggler navbar-toggler  px-2"
          onClick={() => {
            console.log("menu click");
          }}
        >
          <img src={require("../../assets/icon/black/archive.svg")} alt="" />
        </button>
      </div> */}
    </div>
  );
}
